import { TableRoot } from "./TableRoot";
import { TableBodyContent } from "./TableBody";
import { TableHeadContent } from "./TableHead";
import { TableContent } from "./TableContent";
import { TablePaginated } from "./TablePaginated";

export const Table = {
  Body: TableBodyContent,
  Root: TableRoot,
  Head: TableHeadContent,
  Content: TableContent,
  Pagination: TablePaginated,
};
